(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumDefaultMessageDetailController', RptCompendiumDefaultMessageDetailController);

    RptCompendiumDefaultMessageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RptCompendiumDefaultMessage', 'RptLanguage', 'Compendium'];

    function RptCompendiumDefaultMessageDetailController($scope, $rootScope, $stateParams, previousState, entity, RptCompendiumDefaultMessage, RptLanguage, Compendium) {
        var vm = this;

        vm.rptCompendiumDefaultMessage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:rptCompendiumDefaultMessageUpdate', function(event, result) {
            vm.rptCompendiumDefaultMessage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
